import { render, staticRenderFns } from "./SingleGroupClass.vue?vue&type=template&id=26ee31ab"
import script from "./SingleGroupClass.vue?vue&type=script&lang=js"
export * from "./SingleGroupClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports